// Limited-role configurations intentionally omit private fields. Defaults used
// by older screens must not turn those missing values into attempted changes.
export function preparePortalPayload(payload, currentPortal) {
    if (!payload || !currentPortal || Object.prototype.hasOwnProperty.call(currentPortal, "auth")) {
        return payload;
    }
    const result = { ...payload };
    delete result.auth;
    delete result.guardian_csv;
    delete result.paypal_gateway;
    return result;
}
